<template>
	<div class="background">
		<div class="container-fluid login-wrapper">
			<div class="row vertical-center-row">
				<div class="col-lg-4 offset-lg-4 col-md-4 offset-md-4 col-sm-6 offset-sm-3 col-xs-12 login-container no-padding">
					<div class="login-container-background">&nbsp;</div>
					<div class="login-container-content">
						<img 	src="../../assets/img/logo.png"
								class="img-fluid login-brand-image">
						<p class="content-container">
							<b-alert v-bind:show="showWarning" variant="danger">{{ warningText }}</b-alert>
							<b-form v-on:submit.prevent="login">
								<b-form-group
									label="eMail"
									label-for="email">
									<b-form-input id="email"
										type="email"
										v-model.trim="email">
									</b-form-input>
								</b-form-group>
								<b-form-group
									label="Passwort"
									label-for="password">
									<b-form-input id="password"
										type="password"
										v-model.trim="password">
									</b-form-input>
								</b-form-group>
								<b-button type="submit" class="vrnu-button-full" variant="primary">Anmelden</b-button>
							</b-form>
						</p>
					</div>
				</div>
			</div>
		</div>

    <div class="legal">
      <a href="https://www.vrnu.de/service/rechtliche-hinweise/impressum.html" class="vrnu-link">Impressum</a>
      &nbsp;&nbsp;
      <a href="https://www.vrnu.de/service/rechtliche-hinweise/datenschutzhinweis-zur-website.html" class="vrnu-link">Datenschutzerklärung</a>
    </div>
		<div class="creator">
			powered by Unsplash
		</div>
		
	</div>
</template>

<script>
export default {
	data: function() {
		return {
			email: '',
			password: '',
			showWarning: false,
      warningText: '',
		};
	},
	methods: {
		login: function() {
			// Send login request to server using vue-auth
			this.$auth.login({
				body: {
					email: this.email,
					password: this.password,
				},
				fetchUser: true,
				rememberMe: false,
				success: function(res) {
				},
				error: function(err) {
				  if(err.status == 401) {
            // Show wrong credentials warning
            this.warningText = "Die Zugangsdaten sind falsch. Bitte geben Sie korrekte Zugangsdaten ein!";
            this.showWarning = true;

            // Reset the login form
            this.email = '';
            this.password = '';
          } else {
            // Show technical problem warning
            this.warningText = "Ein technisches Problem ist aufgetreten. Bitte wenden Sie sich an den Systemadministrator!";
            this.showWarning = true;
          }
				},
				redirect: {
					name: 'Main',
				}
			});
		},
	}
}
</script>

<style>
.background {
	position: absolute;
	width: 100%;
	height: 100%;
	background: url('https://source.unsplash.com/collection/142324') no-repeat center center fixed; 
	-webkit-background-size: cover;
	-moz-background-size: cover;
	-o-background-size: cover;
	background-size: cover;
}
.legal {
  position: absolute;
  color: #ffffff;
  top: 15px;
  left: 15px;
}
.creator {
	position: absolute;
	color: #ffffff;
	bottom: 15px;
	right: 15px;
}
.login-wrapper {
	height: 100%;
	width: 100%;
	display: table;
}
.login-container {
	position: relative;
}
.content-container {
	text-align: left;
}
.login-container-background {
	position: absolute;
	z-index: 20;
	width: 100%;
	height: 100%;
	
	/* background: #003343; */
	background: #343a40;
	opacity: 0.95;
	filter: alpha(opacity =95);
	
	-webkit-box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.75);
	-moz-box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.75);
	box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.75);
}
.login-container-content {
	position: relative;
	z-index: 20;
	padding: 20px;
	color: #FFFFFF;
}
.login-brand-image {
	margin: 0px 0px 25px 0px;
	padding: 20px;
}
.vertical-center-row {
	display: table-cell !important;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/01_auth/Login.vue